<template>
  <div class="answeredQuestion">
    <label>{{ answer.question.label }}</label>
    <span class="oui" v-if="answer.answer">Oui</span>
    <span class="non" v-else>Non</span>
    <img class="del" src="/assets/icons/cross2.png" @click="deleteAnswer" />
  </div>
</template>

<script>
export default {
  name: "QuizzAnswer",
  props: ["answer", "index"],
  methods: {
    deleteAnswer() {
      this.$emit("delete", this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/quizz.scss";

.del {
  cursor: pointer;
}
</style>
